export const URL_DELIMITER = ';';